/* global axios */
import ApiClient from '../ApiClient';

class WhatsappPresenceApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(`${this.url}/${conversationId}/whatsapp_presence`);
  }
}

export default new WhatsappPresenceApi();
